export const autoConsentBanner = true
      
export const cookieBotId = "f5786028-4ec2-4335-9a8a-e9a7789016bd"
      